/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbaording_Permission_ContentInputs */

const en_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll notify you when:`)
};

const ar_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنقوم بإعلامك عندما:`)
};

const de_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir werden Sie benachrichtigen, wenn:`)
};

const es_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te notificaremos cuando:`)
};

const fr_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous vous préviendrons quand :`)
};

const it_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti informeremo quando:`)
};

const ja_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のタイミングでお知らせします`)
};

const ko_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림을 보내드려요`)
};

const pt_br_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós te notificaremos se:`)
};

const ru_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы получите уведомление, когда:`)
};

const th_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราจะแจ้งเตือนคุณเมื่อ:`)
};

const tr_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seni şu durumlarda bilgilendireceğiz:`)
};

const zh_cn_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们会在这些时候提醒你：`)
};

const zh_tw_onbaording_permission_content = /** @type {(inputs: Onbaording_Permission_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們會在這些時候提醒你：`)
};

/**
* | output |
* | --- |
* | "We'll notify you when:" |
*
* @param {Onbaording_Permission_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onbaording_permission_content = /** @type {((inputs?: Onbaording_Permission_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbaording_Permission_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbaording_permission_content(inputs)
	if (locale === "ar") return ar_onbaording_permission_content(inputs)
	if (locale === "de") return de_onbaording_permission_content(inputs)
	if (locale === "es") return es_onbaording_permission_content(inputs)
	if (locale === "fr") return fr_onbaording_permission_content(inputs)
	if (locale === "it") return it_onbaording_permission_content(inputs)
	if (locale === "ja") return ja_onbaording_permission_content(inputs)
	if (locale === "ko") return ko_onbaording_permission_content(inputs)
	if (locale === "pt_br") return pt_br_onbaording_permission_content(inputs)
	if (locale === "ru") return ru_onbaording_permission_content(inputs)
	if (locale === "th") return th_onbaording_permission_content(inputs)
	if (locale === "tr") return tr_onbaording_permission_content(inputs)
	if (locale === "zh_cn") return zh_cn_onbaording_permission_content(inputs)
	return zh_tw_onbaording_permission_content(inputs)
});